var _title, _desc, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconMirror = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "E5E065F5-8B25-419F-9360-60B0BD96F37E")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/sketch/flip/idle"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F8F8F8",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 3.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8469238,16.1489868 C23.8460083,16.1489868 23.8460083,16.1489868 23.8469238,16.1489868 L15.3460693,0.648925781 C15.1259766,0.249023438 14.7059326,0 14.25,0 C13.5609741,0 12.999939,0.561035156 12.999939,1.25006105 L12.999939,16.749939 C12.999939,17.4389648 13.5609741,18 14.25,18 L22.749939,18 C23.4389648,18 24,17.4389648 24,16.749939 C24,16.5410156 23.9470825,16.3330078 23.8469238,16.1489868 Z",
    id: "Path",
    fill: "#535878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02287542,16.6442778 C1.00802132,16.6774215 1,16.714287 1,16.749939 C1,16.8866801 1.11331991,17 1.25006105,17 L9.75,17 C9.88674114,17 10.000061,16.8866801 10.000061,16.749939 L10.000061,1.25006105 C10.000061,1.11331991 9.88674114,1 9.75,1 C9.65920169,1 9.57457301,1.05012307 9.53074535,1.12975428 L1.02287542,16.6442778 Z",
    id: "Path",
    stroke: "#535878",
    strokeWidth: 2
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconMirror, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-mirror.01eeb2f7.svg";
export { ForwardRef as ReactComponent };